import EditProfile from '../components/Profile/EditProfile';

const ProfileEdit = () => <EditProfile />;

export default ProfileEdit;
